import { QueryClient } from "@tanstack/react-query";
import { ApiProblem } from "@/api/problem";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // a refusal of the API (4xx) is not retried: it would only be refused again
      retry: (failures, error) => !(error instanceof ApiProblem && error.status >= 400 && error.status < 500) && failures < 2,
    },
  },
});
